var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0771 5.25356C10.455 5.29218 10.7499 5.61162 10.75 5.99966C10.75 6.38781 10.4551 6.70712 10.0771 6.74575L10 6.74966H5.25C4.42167 6.74966 3.75016 7.42136 3.75 8.24966V18.7497C3.75 19.5781 4.42158 20.2497 5.25 20.2497H15.75C16.5784 20.2497 17.25 19.5781 17.25 18.7497V13.9997C17.2502 13.5856 17.5859 13.2497 18 13.2497C18.4141 13.2497 18.7498 13.5856 18.75 13.9997V18.7497C18.75 20.4065 17.4069 21.7497 15.75 21.7497H5.25C3.59315 21.7497 2.25 20.4065 2.25 18.7497V8.24966C2.25016 6.59294 3.59324 5.24966 5.25 5.24966H10L10.0771 5.25356Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.0186 2.26821C19.0436 1.24328 20.7064 1.24328 21.7314 2.26821C22.7565 3.29329 22.7564 4.95596 21.7314 5.9811L11.1123 16.5993C10.4956 17.2159 9.73519 17.6696 8.89941 17.9186L6.21387 18.7184C5.95 18.7969 5.6644 18.7246 5.46973 18.5299C5.27516 18.3353 5.20276 18.0496 5.28125 17.7858L6.08105 15.1002C6.33012 14.2645 6.78377 13.504 7.40039 12.8874L18.0186 2.26821ZM8.46094 13.9479C8.02044 14.3884 7.69644 14.9319 7.51855 15.529L7.11426 16.8844L8.4707 16.4811C9.06779 16.3032 9.61122 15.9793 10.0518 15.5387L18.4521 7.13735L16.8613 5.54653L8.46094 13.9479ZM20.6709 3.32876C20.2316 2.88961 19.5184 2.88961 19.0791 3.32876L17.9219 4.48598L19.5127 6.07681L20.6709 4.92056C21.1101 4.4812 21.1102 3.76805 20.6709 3.32876Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.1a8ba7f8084b13a8da04fb7807138c8d.svg";
export { ForwardRef as ReactComponent };